import { useLocale } from "../../services/DataContext"


export interface IListViewItem {
  name: string;
  rank: number;
  value: number;
}


export interface ListViewProps {
  data: IListViewItem[];
}

export const ListView: React.FC<ListViewProps> = ({ data }) => {
  const l: any = useLocale();
  return <div className="container">
    <div className="row">
      <div className="col">
        <ul className="list-view">
          <li className="list-view__item">
            <div className="list-view__col-h list-view__col-h--rank">
              <p>{l["rank"]}</p>
            </div>
            <div className="list-view__col-h list-view__col-h--name">
              <p className="s">{l["name"]}</p>
            </div>
            <div className="list-view__col-h list-view__col-h--value">
              <p className="c">{l["avgHype"]}</p>
            </div>
          </li>
          {
            data.map(e => {
              return <li className="list-view__item">
                <div className="list-view__col list-view__col--rank">
                  <p>{e.rank}</p>
                </div>
                <div className="list-view__col list-view__col--name">
                  <p className="s">{e.name}</p>
                </div>
                <div className="list-view__col list-view__col--value">
                  <p className="c">{Math.round(e.value)}</p>
                </div>
              </li>
            })
          }
        </ul>
      </div>
    </div>
  </div>
}